
import { css } from '@emotion/react';
import { colorVariables, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const StyledLinkContainerStyle = css`
    font-weight: ${fontWeights.lightBold};
    margin-top: 6px;
`;

export const StyledShowMoreContainerStyle = css`
    color: ${colorVariables.textLink};
    cursor: pointer;

    .chevron {
        margin-left: ${gutterSizes.base};
    }
`;
